import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import * as pluviometroActions from './pluviometroActions';
import MapaFaseGeral from '../fase/mapaFaseGeral';

class PluviometroMapa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshKey: 0,
    };
  }

  render() {
    return (
      <div>
        <Content>
          <div className="row">
            <div className="col-md-12">
              <div className="box box-primary">
                <div className="box-body">
                  <MapaFaseGeral key={this.state.refreshKey} visualizacao="pluviometrico" />
                </div>
              </div>
            </div>
          </div>
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...pluviometroActions,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PluviometroMapa);
